import React from "react";

interface ConfirmationModalProps {
  isOpen: boolean;
  text: string;
  onYes: () => void;
  onNo: () => void;title:string
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  text,
  onYes,
  onNo,title
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <h2 className="text-lg font-semibold text-gray-900">
          {title}
        </h2>

        <p className="mt-3 text-sm text-gray-600">
          {text}
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onNo}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            No
          </button>

          <button
            type="button"
            onClick={onYes}
            className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;